export default __webpack_public_path__ + "static/escritorioCampinas-07527bb7ca66b32ef4d5b8fe585ad679.jpg";